import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from '../shared/services/core/api.service';
import { MemberNetworkStore } from './member-network.store';
import { MemberNetworkModel } from './models/member-network.model';
import { MemberQuery } from '../account/member/member.query';
import { UserContext } from '../account/member/models/user-context.model';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class MemberNetworkService {
  constructor(
    private networkStore: MemberNetworkStore,
    private memberQuery: MemberQuery,
    private api: ApiService
  ) {}

  /** Fetch all the Network members and puts them in the store.*/
  fatchNetworkMembers(
    returnPoints: boolean = true,
    returnCashBack: boolean = true,
    returnTierPoints: boolean = true
  ): Observable<MemberNetworkModel[]> {
    let userContext = this.memberQuery.getValue().user as UserContext;

    const queryParams = new HttpParams()
      .set('returnPoints', returnPoints)
      .set('returnCashBack', returnCashBack)
      .set('returnTierPoints', returnTierPoints);

    const request$: Observable<MemberNetworkModel[]> = this.api
      .getById<MemberNetworkModel[]>('network', userContext.externalRef, queryParams)
      .pipe(
        tap((network) => {
          this.networkStore.set(network);
        })
      );

    return request$;
  }

  /**
   * Add new member to your network
   * @param offerId is the external Reference number of the user you want to add.
   * @param offerId is the last name of the user you want to add.
   */
  addMemberToNetwork(externalRefNumber: string, surname: string) {
    const queryParams = new HttpParams().set('externalRefNumber', externalRefNumber).set('surname', surname);

    return this.api.post<{}>('network', {}, queryParams).pipe(
      tap((res) => { this.networkStore.update(res.RelationshipId, res); })
    );
  }

  /** This endpoint is used to delete the member from your network */
  deleteMemberFromNetwork(memberId: string) {
    return this.api.delete(`network`, memberId).pipe(tap(this.networkStore.remove(memberId)));
  }
}
